module.exports = __webpack_public_path__ + "static/media/Poppins-Italic.5e956c44.ttf";